import { Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { CancelIcon, CheckMarkIcon, SaveIcon } from "../../../common/icons";
import { useApolloClient, useMutation } from "@apollo/client";
import { ORG_VALUE_LISTS } from "../../../../graphql/valuelist-gql";
import { IValueListLight } from "../../../../types/valuelist";
import {  useEffect, useState } from "react";
import {  GET_ORG_ROLES, GET_ROLE_DETAIL, UPDATE_ROLE } from "../../../../graphql/position-gql";
import { notifySuccess } from "../../../../services/notification";
import { messages } from "../../../../i18n/message";
import { LOCALES } from "../../../../i18n/locales";
import { IPosition, IPositionInput, IPositionTitle } from "../../../../types/position";
import PositionTypeahead from "../../../common/typeahead/position-typeahead";
import Select from "../../../common/select/select";
import { formatExcludeComma } from "../../../../types/constants";
import { deepEqual } from "../../../../utils/commons";
import Info from "../../../common/info";
import { fullTitle } from "../../../../utils/full-title";
import useAuth from "../../../../hook/useAuth";
import "./role-information.scss";
import { useFrench } from "../../../french/french-context";
import Button from "../../../common/button";
import SpinnerOverlay from "../../../common/spinner/spinner";
type RoleInformationProp = {
    role:IPosition
    updateSelectedRole?:(updatedRole:IPosition)=>void

}

const RoleInformation =(prop:RoleInformationProp)=>{
    const {role,updateSelectedRole} = prop;
    const [prefixLengthError,setPrefixLengthError] = useState<string>('');
    const [prefixCharError,setPrefixCharError] = useState<string>('');
    const [suffixLengthError,setSuffixLengthError] = useState<string>('');
    const [suffixCharError,setSuffixCharError] = useState<string>('');
    const [titleError,setTitleError] = useState<string>('');
    const [selectedPositionTitle,setSelectedPositionTitle] = useState<IPositionTitle>({positionTitleId:role.positionTitle.positionTitleId,positionName:role.positionTitle.positionName});
    const [anyChange,setAnychange] = useState<boolean>(false);
    const [valid,setValid] = useState<boolean>(true);
    const [positionFullTitle,setPositionFullTitle] =  useState<string>('');
    const [ updateRole, {loading} ] = useMutation(UPDATE_ROLE);
    const client = useApolloClient()
    const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
    const { isFrenchTranslator } = useAuth()
    const [editedRole, setEditedRole] = useState<Partial<IPositionInput>>(
        {positionTitleId:0, positionHonorificId:0, positionPrefix:'',positionSuffix:'', positionName:'',
         bilingualIndicator:false
        }
    )

    const initRoleInput = () => {
        const init : IPositionInput = {
            positionTitleId: role.positionTitle.positionTitleId, 
            positionName: role?.positionName,
            positionHonorificId:role.positionHonorificId, 
            positionPrefix:role.positionPrefix?role.positionPrefix:'', 
            positionSuffix:role.positionSuffix?role.positionSuffix:'',
            bilingualIndicator:role.bilingualIndicator,
            managementIndicator:false, 
            positionNameFMSync: role.positionNameFMSync,
            positionNameFFSync:role.positionNameFFSync,
            positionNameFM: role.positionNameFM,
            positionNameFF: role.positionNameFF
        }
        return init;
    }

    const [frenchState] = useFrench();

    useEffect(() => {
        if (role) {
            //console.log("role:",role.fullPositionName)
            setEditedRole(initRoleInput())
            setPositionFullTitle(role.fullPositionName)
        }
    }, [role])

    useEffect(() => {

        if(editedRole?.positionPrefix && editedRole?.positionPrefix?.length>100)
            setPrefixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
            setPrefixLengthError('')

        if(editedRole?.positionPrefix && formatExcludeComma.test(editedRole?.positionPrefix))
            setPrefixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setPrefixCharError('')

        if(editedRole?.positionSuffix && editedRole?.positionSuffix?.length>100)
            setSuffixLengthError(messages[LOCALES.ENGLISH].ERROR['5612'])
        else
            setSuffixLengthError('')

        if(editedRole?.positionSuffix && formatExcludeComma.test(editedRole?.positionSuffix))
            setSuffixCharError(messages[LOCALES.ENGLISH].ERROR['5613'])
        else
            setSuffixCharError('')

        setAnychange(!deepEqual(initRoleInput(),editedRole));

    }, [editedRole])

    useEffect(() => {
        setValid(editedRole?.positionTitleId!==0
            && !titleError
            && !prefixCharError && !prefixLengthError
            && !suffixCharError && !suffixLengthError)
    },[titleError,prefixCharError,prefixLengthError,suffixCharError,suffixLengthError,editedRole]);

    const updatePositionFullName = (prefix:string|undefined,positionName:string|undefined,suffix:string|undefined) =>{
        const myfullTitle = fullTitle(undefined,prefix,positionName,suffix)
        setPositionFullTitle(myfullTitle);
    }

    const titleSelected = (positionTitle: IPositionTitle | null) => {
        setSelectedPositionTitle(positionTitle||{positionTitleId:0,positionName:''})  
        setEditedRole({ ...editedRole, positionTitleId: positionTitle?.positionTitleId||0,positionNameFMSync: false, positionNameFFSync: false})
        updatePositionFullName(editedRole?.positionPrefix,positionTitle?.positionName,editedRole?.positionSuffix)
        //console.log("positionTitle:",positionTitle)
    }
    const onRolePrefixChange = (event: any) => {
        setEditedRole({ ...editedRole, positionPrefix: event.target.value,positionNameFMSync: false, positionNameFFSync: false})
        updatePositionFullName(event.target.value,selectedPositionTitle?.positionName,editedRole?.positionSuffix)
    }
    const onRoleSuffixChange = (event: any) => {
        setEditedRole({ ...editedRole, positionSuffix: event.target.value ,positionNameFMSync: false, positionNameFFSync: false})  
        updatePositionFullName(editedRole?.positionPrefix,selectedPositionTitle?.positionName, event.target.value)
    }
    const onHonorificChange = (event: any) => {setEditedRole({ ...editedRole, positionHonorificId: event.target.value })}

    const honorific = () =>{
        if(editedRole.positionHonorificId && orgValueLists?.posHonorifics){
            const orgValueList = orgValueLists.posHonorifics.find((item:IValueListLight)=>item.id===editedRole.positionHonorificId)
            return orgValueList?orgValueList.label:'';
        }
    }
    const onbilingualIndicatorChange = (event: any) => {setEditedRole({ ...editedRole, bilingualIndicator: !editedRole.bilingualIndicator })}
    const onRoleNameFMSyncChange = (event: any)=>{setEditedRole({ ...editedRole, positionNameFMSync: event.target.checked })}
    const onRoleNameFFSyncChange = (event: any)=>{setEditedRole({ ...editedRole, positionNameFFSync: event.target.checked })}
    const getRefetchQuery = () => {return [{query: GET_ROLE_DETAIL, variables: { roleId: role.positionId}}]}
    const onSaveHandle = () => {
        const inputRole = {...editedRole}
        delete inputRole.positionName;
        //console.log("inputPosition:",inputPosition)
        updateRole({
            variables: {
                roleId: role?.positionId,
                input: {
                    ...inputRole
                }
            },
            update(cache,{data:{updateRole}}){
                //update for position list
                //console.log("updateRole:",updateRole)
                const cachedOrg = cache.readQuery<{
                    org:{
                        roles:Array<IPosition>
                    }
                }>({
                    query: GET_ORG_ROLES,
                    variables: { orgId: role?.orgId||undefined},
                  });

                if(cachedOrg){

                    const updatedRoles = [...cachedOrg.org.roles];
                    const updatedRoleIndex = updatedRoles.findIndex(
                        (role: IPosition) => role.positionId === updateRole.positionId
                      );
                    // Modify the cache data to reflect the mutation result
                    if (updatedRoleIndex !== -1) {
                        updatedRoles[updatedRoleIndex] = updateRole;
                        //console.log("updatedRoles:",updatedRoles)
                    }
                    // Update the cached data with the modified positions array
                    cache.writeQuery({
                        query: GET_ORG_ROLES,
                        variables: { orgId: role?.orgId||undefined},
                        data: {
                            org: {
                                ...cachedOrg.org,
                                roles: updatedRoles,
                            },
                        },
                    });

                    updateSelectedRole&&updateSelectedRole({...role,...updateRole});

                }

            },
            refetchQueries: getRefetchQuery(),
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                data && notifySuccess()
            }
        })
    }

    return (<>{loading && <SpinnerOverlay></SpinnerOverlay>}<div role="region" aria-label="Role Detail" className="roleDetail">
                <Form>
                    <Info ><b>Full Title Preview:</b>&nbsp;{positionFullTitle} </Info>
                    {
                        frenchState.isFrenchChecked && <>
                            <Info><b>Full Title Preview (French - Masculine):</b>&nbsp;<span lang="fr">{editedRole.positionNameFM}</span></Info>
                            <FormGroup row>
                                <div className='col-md-3'>
                                    <Input id="nameTranslated" type="checkbox" checked={editedRole?.positionNameFMSync || false} onChange={onRoleNameFMSyncChange} disabled={!editedRole.positionNameFM}/> {' '}
                                    <Label for="nameTranslated" role="region" aria-label='Translated Full Title Masculine'>Translated Full Title Masculine</Label>
                                </div>
                            </FormGroup>
                            <Info><b>Full Title Preview (French - Feminine):</b>&nbsp;<span lang="fr">{editedRole.positionNameFF}</span></Info>
                            <FormGroup row>
                                <div className='col-md-3'>
                                    <Input id="nameTranslated1" type="checkbox" checked={editedRole?.positionNameFFSync || false} onChange={onRoleNameFFSyncChange} disabled={!editedRole.positionNameFF}/> {' '}
                                    <Label for="nameTranslated1" role="region" aria-label='Translated Full Title Feminine'>Translated Full Title Feminine</Label>
                                </div>
                            </FormGroup>
                        </>
                    }
                    <br/>
                    <Row>
                        <Col md={6}>
                        <FormGroup row>
                                <Label for="role-info-title" sm={4}>Title(required):</Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator && <PositionTypeahead elementId="role-info-title" positionTitleSelected={titleSelected} init={role.positionTitle} validate={setTitleError} isRole={role.isRole}/>}
                                    {isFrenchTranslator && <div id="role-info-title">{selectedPositionTitle.positionName}</div>}
                                </Col>
                            </FormGroup>
                        </Col>  
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="role-info-prefix" sm={4}>
                                    Prefix:
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator &&<div>
                                            <Input id="role-info-prefix" aria-labelledby="role-info-prefix"  value={editedRole?.positionPrefix||''}
                                                onChange={onRolePrefixChange}  placeholder="Enter a prefix for the role title"
                                                invalid={!!prefixLengthError || !! prefixCharError}/>
                                            <FormFeedback>{prefixLengthError}</FormFeedback>
                                            <FormFeedback>{prefixCharError}</FormFeedback>           
                                        </div>}
                                    {isFrenchTranslator &&
                                    <div>{editedRole.positionPrefix}</div>}
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row> 
                    <Row>
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="role-info-suffix" sm={4}>
                                    Suffix:
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator &&
                                    <div>  
                                        <Input id="role-info-suffix" value={editedRole?.positionSuffix||'' } placeholder="Enter a suffix for the role title"
                                            onChange={onRoleSuffixChange} 
                                            invalid={!!suffixLengthError || !! suffixCharError}/>                                       
                                        <FormFeedback>{suffixLengthError}</FormFeedback>
                                        <FormFeedback>{suffixCharError}</FormFeedback>
                                    </div>
                                    }
                                    {isFrenchTranslator &&<div>{editedRole.positionSuffix}</div>}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup row>
                                <Label for="role-info-honorific" sm={4}>
                                    Honorific:
                                </Label>
                                <Col sm={8}>
                                    {!isFrenchTranslator &&  <div>   
                                        <Select id="role-info-honorific"  value={editedRole?.positionHonorificId || 0 } onChange={onHonorificChange} >
                                            <option value='0' disabled>Select an honorific for the role title</option>
                                            <option value='-1'></option>
                                            {orgValueLists.posHonorifics.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                                        </Select>
                                    </div>}
                                    {isFrenchTranslator &&<div>{honorific()}</div>}
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>   
                    <Row>
                        <Col sm={12}>
                            { (!isFrenchTranslator || frenchState.isFrenchChecked) &&<Button color="primary" style={{marginRight:'20px'}} onClick={onSaveHandle} disabled={!valid || !anyChange}><SaveIcon /> Save Changes</Button>}
                            { !isFrenchTranslator && <Input id="role-info-bilingualIndicator" type="checkbox" style={{verticalAlign:'middle'}} checked={editedRole?.bilingualIndicator||false} onChange={onbilingualIndicatorChange}/>}
                            
                            { isFrenchTranslator && editedRole?.bilingualIndicator && <CheckMarkIcon />}
                            { isFrenchTranslator && !editedRole?.bilingualIndicator && <CancelIcon />}   
                        
                            <Label for="role-info-bilingualIndicator" check style={{verticalAlign:'middle',marginRight:'20px'}}>
                                &nbsp;Role is Bilingual
                            </Label>
                        </Col> 
                    </Row>      
                </Form>
            </div></>)
}

export default RoleInformation;
